'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transformers = {
  'b': "background",
  'c': "crop",
  'e': "embed",
  'h': "height",
  'q': "quality",
  'r': "rotate",
  's': "ratio",
  'w': "width"
};
var transformersReverse = {};
for (var k in transformers) {
  transformersReverse[transformers[k]] = k;
}

exports.default = function () {
  var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cdnUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : process.env.REACT_APP_CDN_URL;
  var filename = file.filename;

  var fileFormatRegex = /\.([a-zA-Z0-9\d]*)$/g;
  var fileExt = (fileFormatRegex.exec(filename) || []).pop() || '';
  var guid = filename.slice(0, -(fileExt.length + 1));
  var transforms = '';

  if (['jpg', 'jpeg', 'png'].indexOf(fileExt) > -1) {
    var matched = Object.keys(transformersReverse).filter(function (tf) {
      return !!params[tf];
    }).map(function (param) {
      return { 'key': transformersReverse[param], 'value': params[param] };
    });
    transforms = matched.length ? ',' : '';
    transforms += matched.map(function (k) {
      return k.key + '_' + k.value;
    }).join(',');
  } else {
    if (Object.keys(params).length) {
      console.warn('Cannot specify transforms for non image file', file);
    }
  }
  return cdnUrl + guid + transforms + '.' + fileExt;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/sls-zone-cdn-helper/lib/index.js
// module id = 802
// module chunks = 0